export default __webpack_public_path__ + "static/media/nextjs.d7da484e.png";